<!-- 업체 선택용 공통 팝업 -->
<template>
  
  <div class="search-bar">
    <span class="search-icon">🔍</span>
    <input type="text" class="search-input" placeholder="검색어를 입력하세요..." @keyup.enter="searchbar_run" v-model="search_keyword">
  </div>


</template>

<script>
    export default {
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
        
        },

        data: ()=> ({
          search_keyword: '',
        }),

        methods: {

          //외부에서 검색어 셋팅
          setSearch(search){
            this.search_keyword = search;
          },
          
          searchbar_run(){
            this.$emit('searchcallback', this.search_keyword);
          },

        }

    }
</script>

<style scoped>

/* 검색 영역 */
.search-bar {
  width: 320px;
  max-width: 100%;
  position: relative;
  margin: 0 auto;
}

.search-input {
  width: 100%;
  height: 40px;
  padding: 0 16px 0 40px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #7C4DFF;
  box-shadow: 0 0 0 2px rgba(124, 77, 255, 0.1);
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #5f6368;
  font-size: 16px;
}


</style>